import axios from 'axios';

/**
 * Extracts a human-readable message from an API error. Resolution order:
 *   1. `{ message }` bodies (Conflict / BadRequest from the receipts API)
 *   2. RFC7807 `title` (validation problem details)
 *   3. the first entry of RFC7807 `errors`
 *   4. the caller-supplied fallback
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { message?: string; title?: string; errors?: Record<string, string[]> }
      | undefined;

    if (data?.message) return data.message;
    if (data?.title) return data.title;

    if (data?.errors) {
      const first = Object.values(data.errors).flat().find((m) => !!m);
      if (first) return first;
    }
  }
  return fallback;
}
